import i18n from '@/i18n'
import { getApiErrorCode } from '@/utils/error'

const DORMAKABA_SERVICE_UNAVAILABLE_STATUS = 400

export const getDormakabaActivationErrorMessage = (error: unknown, fallbackMessage: string) =>
  getApiErrorCode(error) === DORMAKABA_SERVICE_UNAVAILABLE_STATUS
    ? i18n.t('clients:keylessAccess.dormakaba.errors.serviceUnavailable')
    : fallbackMessage
